import React, { useState } from 'react'
import CenterInfo from '../components/CenterInfo/CenterInfo'

const CenterInfoPage = () => {
  return (
    <>
      <CenterInfo />
    </>
  )
}

export default CenterInfoPage
